import { RouteObject } from 'react-router-dom'
import { lazy } from 'react'
import ModuleGuard from '@/core/guards/ModuleGuard.tsx'
import ErrorPage from '@/pages/errors/ErrorPage.tsx'

const INSURERS_ROUTES: RouteObject[] = [
  {
    path: 'insurers',
    element: <ModuleGuard />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: 'service-centers',
        lazy: async () => {
          const ServiceCentersPage = lazy(
            () =>
              import('@/pages/insurers/serviceCenters/ServiceCentersPage.tsx')
          )
          return { element: <ServiceCentersPage /> }
        }
      },
      {
        path: 'rentability-configuration',
        lazy: async () => {
          const RentabilityConfigurationsPage = lazy(
            () =>
              import(
                '@/pages/insurers/rentabilityConfigurations/RentabilityConfigurationsPage.tsx'
              )
          )
          return { element: <RentabilityConfigurationsPage /> }
        }
      },
      {
        path: 'claims',
        lazy: async () => {
          const ClaimsPage = lazy(
            () => import('@/pages/insurers/claims/ClaimsPage.tsx')
          )
          return { element: <ClaimsPage /> }
        }
      }
    ]
  }
]

export default INSURERS_ROUTES
